import React from "react";

const getTooltipText = (title) => {
  if (typeof title === "string") return title;
  if (Array.isArray(title)) return title.map(getTooltipText).filter(Boolean).join("\n");
  if (React.isValidElement(title)) {
    return getTooltipText(title.props?.children);
  }
  return title ? String(title) : "";
};

const StyledTooltip = ({ children, className = "", title, ...props }) => {
  const tooltipText = getTooltipText(title);
  const spanProps = { ...props };
  [
    "arrow",
    "disableFocusListener",
    "disableHoverListener",
    "disableTouchListener",
    "enterDelay",
    "leaveDelay",
    "placement"
  ].forEach((key) => {
    delete spanProps[key];
  });

  return (
    <span
      className={`inline-flex ${className}`.trim()}
      title={tooltipText}
      {...spanProps}
    >
      {children}
    </span>
  );
};

export default StyledTooltip;
